import { SYSTEM } from './prompts';

async function callClaude(messages, useSearch) {
  const body = {
    model: 'claude-sonnet-4-20250514',
    max_tokens: 8000,
    system: SYSTEM,
    messages,
  };
  if (useSearch) {
    body.tools = [{ type: 'web_search_20250305', name: 'web_search' }];
  }

  const res = await fetch('/api/claude', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  const data = await res.json().catch(() => null);

  if (!res.ok) {
    const msg = data?.error?.message || data?.error || `HTTP ${res.status}`;
    throw new Error(msg);
  }

  return data;
}

export async function runAudit(userPrompt) {
  let messages = [{ role: 'user', content: userPrompt }];
  let data = await callClaude(messages, true);
  let loopCount = 0;

  while (data.stop_reason === 'tool_use' && loopCount < 8) {
    loopCount++;
    messages.push({ role: 'assistant', content: data.content });
    const toolResults = data.content
      .filter(b => b.type === 'tool_use')
      .map(b => ({ type: 'tool_result', tool_use_id: b.id, content: 'Search completed.' }));
    messages.push({ role: 'user', content: toolResults });
    data = await callClaude(messages, true);
  }

  const text = (data.content || [])
    .filter(b => b.type === 'text')
    .map(b => b.text)
    .join('\n');

  if (!text.trim()) throw new Error('Empty response — please try again.');
  return text;
}
